export default __webpack_public_path__ + "static/Greycliffcf-extrabold-webfont-359983eda658807e1a621859459570bf.woff";